import * as Immutable from 'immutable'
import walkInInterestsService from '../../../services/walk-in-interests-service'
// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_WALK_IN_INTERESTS_BY_REFS = 'LOAD_WALK_IN_INTERESTS_BY_REFS'

export function loadWalkInInterestsByRefs (refs) {
  return (dispatch, getState) => {
    return walkInInterestsService.getWalkInInterestsByRefs(refs).then((walkInInterests) => {
      dispatch({
        type: LOAD_WALK_IN_INTERESTS_BY_REFS,
        walkInInterests: walkInInterests
      })
    })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultState = Immutable.fromJS([])

export function loadWalkInInterestsByRefsReducer (state = defaultState, action) {
  switch (action.type) {
    case LOAD_WALK_IN_INTERESTS_BY_REFS: {
      return Immutable.fromJS(action.walkInInterests)
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/WalkInInterestsPrint/modules/WalkInInterestsPrint.js